import {createAction, props} from '@ngrx/store';
import {MarketOrderDetails, OrderPagedResponse} from '@app/marketplace/orders/_models/order.interface';

export const LOADING_ORDER_DETAILS = '[Order-Details] Loading order details';
export const ORDER_DETAILS = '[Order-Details] get order details';
export const ERROR_ORDER_DETAILS = '[Order-Details] Order Details Loaded Error';
export const CANCEL_ORDER_DETAILS_REQUEST = '[Order-Details] Cancel order details request';

export const LoadingOrderDetailsAction = createAction(
  LOADING_ORDER_DETAILS,
  props<{ orderCode: string }>()
);
export const GetOrderDetailsAction = createAction(
  ORDER_DETAILS,
  props<{ data: MarketOrderDetails, orderCode: string }>()
);
export const CancelOrderDetailsRequestAction = createAction(
  CANCEL_ORDER_DETAILS_REQUEST,
  props<{ orderCode: string }>()
);
